import styled from '@emotion/styled'
import mq from 'theme/mediaQueries'

export const ContainerName = styled.div`
  grid-template-columns: 140px auto 100px;

  ${mq({
    display: ['block', 'block', 'grid', 'grid'],
  })}

  button {
    width: 50px;
  }
`

export const ContainerPrice = styled.div`
  display: grid;
  grid-template-columns: 140px auto 200px 150px;

  ${mq({
    display: ['block', 'block', 'grid', 'grid'],
  })}
`
